import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.prototype.$store = store;
import "./utils/element";
import "./styles/index.scss";

import JsEncrypt from "./utils/jsencrypt";
Vue.prototype.$jsEncrypt = new JsEncrypt();

import dayjs from "dayjs";
Vue.prototype.$dayjs = dayjs;

//路由拦截
router.beforeEach((to, from, next) => {
  let path = to.path;
  if (path && path !== "/login" && path !== "/error") {
    let token = localStorage.auth_token;
    if (token) {
      const menuMap = store.getters.getMenuMap;
      if (!menuMap[path]) {
        next({ path: "/error" });
      }
      if (to.matched && to.matched.length > 0) {
        let match = to.matched[0];
        let menuPath = match.path.substring(1);
        store.commit("setMenuRouter", menuPath);
      }
      store.commit("setCurrentRouter", path);
    } else {
      Vue.prototype.$message({
        message: "没有权限",
        type: "error",
      });
      Vue.prototype.$logout();
    }
  }
  next();
});

const logout = () => {
  localStorage.clear();
  setTimeout(() => {
    let routerName = window.location.pathname;
    if (routerName == "/login") {
      window.location.reload();
    } else {
      window.location.href = "/login";
    }
  }, 0);
};
Vue.prototype.$logout = logout;

Vue.config.productionTip = false;

import { getUserSystem } from "./utils/getUserSystem";

new Vue({
  router,
  store,
  render: (h) => h(App),
  async created() {
    if (localStorage.auth_token) {
      await getUserSystem();
    }
  },
}).$mount("#app");
